const events = {
    LOADING: 'three/objects/1:loading',
    STATECHANGE: 'statechange',
    SETCHANGING: 'setchanging'
}

enum layers {
    NONE,
    TORUS_SCENE,
    BLOOM_SCENE,
    ENTIRE_SCENE,
}

export { events, layers }